$(document).ready(() => {
  const formatGbp = amount => {
    const num = typeof amount === 'string' ? Number(String(amount).replace(/[£$,]/g, '')) : Number(amount)
    return `£${num.toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}`
  }

  $.ajax({
    type: 'GET',
    url: '/products/alkaline-ro-water-filter-for-tap-g5p700a.js',
    dataType: 'json',
    success(product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(2)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(2)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $.ajax({
    type: 'GET',
    url: '/products/reverse-osmosis-system-x12.js',
    dataType: 'json',
    success(product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(0)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(0)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $.ajax({
    type: 'GET',
    url: '/products/waterdrop-reverse-osmosis-water-filtration-system.js',
    dataType: 'json',
    success(product) {
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(1)
        .find('.wd-compare-detail-item-product-price')
        .html(formatGbp(product.price / 100))
      $('.wd-compare-header .wd-compare-header-item')
        .eq(1)
        .find('.wd-compare-header-item-price')
        .html(formatGbp(product.price / 100))
    }
  })
  $(window).on('scroll', function () {
    const scrollTop = $(this).scrollTop()
    const offsetTop = $('.wd-compare-content').offset().top
    if (scrollTop > offsetTop) {
      $('.wd-compare-header').css('display', 'block')
    } else {
      $('.wd-compare-header').css('display', 'none')
    }
  })

  let wd_compare_index
  let pre_index
  let compareSwitching = false

  const lockCompareSelects = () => {
    compareSwitching = true
    $('.wd-compare').addClass('wd-compare-switching')
  }

  const unlockCompareSelects = () => {
    compareSwitching = false
    $('.wd-compare').removeClass('wd-compare-switching')
  }

  const window_width = $(window).width()
  if (window_width <= 1024) {
    $('.wd-compare-product .wd-compare-detail-item-product-choose-card-items')
      .eq(0)
      .find('.wd-compare-detail-item-product-choose-card-item[data-index="9"]')
      .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
    $('.wd-compare-product .wd-compare-detail-item-product-choose-card-items')
      .eq(1)
      .find('.wd-compare-detail-item-product-choose-card-item[data-index="9"]')
      .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
  }

  $('.wd-compare-detail-item-product-choose-select').click(function () {
    if (compareSwitching) {
      return false
    }
    wd_compare_index = $(this).parents('.wd-compare-detail-item').index()
    pre_index = $(this)
      .siblings('.wd-compare-detail-item-product-choose-card')
      .find(`.wd-compare-detail-item-product-choose-card-item-active`)
      .attr('data-index')

    if (window_width <= 767) {
      $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'block')
      $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'flex')
      $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'block')
      $('html').css('overflow', 'hidden')
      $('.wd-compare').css('z-index', '99')
      $(this).siblings('.wd-compare-detail-item-product-choose-select-mobile').css('border-bottom', '1px solid #2179CA')
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-select-mobile')
        .css('border-bottom', '1px solid #e2e2e2')
    }
    $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
    $(this).siblings('.wd-compare-detail-item-product-choose-card').stop().slideDown()
  })

  $('.wd-compare-detail-item-product-choose-select.wd-compare-detail-item-product-choose-select-mobile').click(
    function () {
      if (compareSwitching) {
        return false
      }
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-card')
        .css('display', 'none')
      $(this)
        .parents('.wd-compare-detail-item')
        .siblings()
        .find('.wd-compare-detail-item-product-choose-select-mobile')
        .css('border-bottom', '1px solid #e2e2e2')
      $(this).siblings('.wd-compare-detail-item-product-choose-card').css('display', 'block')
      $(this).css('border-bottom', '1px solid #2179CA')
    }
  )

  $('.wd-compare-detail-item-product-choose-card').mouseleave(function () {
    $(this).stop().slideUp()
  })
  $('.wd-compare-detail-item-product-choose-card-item').hover(
    function () {
      $(this).addClass('wd-compare-detail-item-product-choose-card-item-hover')
    },
    function () {
      $(this).removeClass('wd-compare-detail-item-product-choose-card-item-hover')
    }
  )
  $('.wd-compare-detail-item-product-choose-card-popup-close').click(function () {
    $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
    $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'none')
    $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'none')
    $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'none')
    $('html').css('overflow', 'auto')
    $('.wd-compare').css('z-index', 'auto')
  })

  $('.wd-compare-detail-item-product-choose-card-item').click(function () {
    if (compareSwitching || $(this).hasClass('wd-compare-detail-item-product-choose-card-item-choosed')) {
      return false
    }
    if (window_width <= 1024) {
      $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
      $('.wd-compare').css('z-index', 'auto')
    }
    if (window_width <= 767) {
      $(this).parents('.wd-compare-detail-items').find('.wd-compare-detail-item-product-choose-card').stop().slideUp()
      $('.wd-compare-detail-item-product-choose-card-popup').css('display', 'none')
      $('.wd-compare-detail-item-product-choose-select-mobile').css('display', 'none')
      $('.wd-compare-detail-item-product-choose-card-popup-close').css('display', 'none')
      $('html').css('overflow', 'auto')
    }

    const data_index = $(this).attr('data-index')
    if (data_index !== pre_index) {
      $('.wd-compare-detail-item-product-choose-card-items')
        .find(`[data-index="${pre_index}"]`)
        .removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
      pre_index = data_index
    }
    $(this).siblings().removeClass('wd-compare-detail-item-product-choose-card-item-active')
    $(this).addClass('wd-compare-detail-item-product-choose-card-item-active')
    $(this).removeClass('wd-compare-detail-item-product-choose-card-item-choosed')
    $(this)
      .parents('.wd-compare-detail-item')
      .siblings()
      .find('.wd-compare-detail-item-product-choose-card-item')
      .each(function () {
        if ($(this).attr('data-index') === data_index) {
          $(this).addClass('wd-compare-detail-item-product-choose-card-item-choosed')
        }
      })

    const product_title = $(this).find('.wd-compare-detail-item-product-choose-card-item-title').html().trim()
    const product_value = $(this).data('value')
    const columnIndex = $(this).parents('.wd-compare-detail-item').index()
    wd_compare_index = columnIndex

    $(this)
      .parents('.wd-compare-detail-item-product-choose')
      .find('.wd-compare-detail-item-product-choose-select .wd-compare-detail-item-product-choose-name')
      .html(product_title)

    $(this)
      .parents('.wd-compare')
      .find('.wd-compare-header-item')
      .eq(columnIndex)
      .find('.wd-compare-header-item-title')
      .html(product_title)
    lockCompareSelects()
    $.ajax({
      type: 'GET',
      url: `/products/${product_value}.js`,
      dataType: 'json',
      success(product) {
        $('.wd-compare-product .wd-compare-detail-item')
          .eq(columnIndex)
          .find('.wd-compare-detail-item-product-price')
          .html(formatGbp(product.price_max / 100))
        $('.wd-compare-header .wd-compare-header-item')
          .eq(columnIndex)
          .find('.wd-compare-header-item-price')
          .html(formatGbp(product.price_max / 100))
      },
      complete() {
        unlockCompareSelects()
      }
    })

    edit_info(product_title)
  })

  function edit_info(title) {
    if (title == 'G3P800') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G3P8OO-W-FC-min.png?v=1770183414'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G3P8OO-W-FC-min.png?v=1770183414'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/tankless-reverse-osmosis-system-g3p800')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('800 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.56 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  6s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 240ml`)

      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`45.9 × 14.4 × 45.1 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`14.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 42, 53, 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`9 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-G3P600-and-G3P800.pdf?v=1677668629">View
            the report ></a>
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-wd-g3-n1cf-filter-replacement">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/waterdrop-cf-g3-icon1.png?v=1622532733"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N1CF
        </div>
        <div class="wd-compare-detail-item-text">
            CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-wd-g3-n3cb-filter-replacement">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/waterdrop-cb-g3-icon1.png?v=1622531945&width=1946"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N3CB
        </div>
        <div class="wd-compare-detail-item-text">
            CB-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href=" https://www.waterdropfilter.co.uk/products/reverse-osmosis-water-filter-g3p800-n2ro">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/800.png?v=1783994799"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3P800-N2RO
        </div>
        <div class="wd-compare-detail-item-text">
            RO-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(163))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'G3P600') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G3P600-min.png?v=1763629457'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G3P600-min.png?v=1763629457'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/waterdrop-reverse-osmosis-water-filtration-system')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('600 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.42 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  6.5s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`46.0 × 14.4 × 45.0 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`14.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 42, 53, 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-6.png?v=1681377284" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-7.png?v=1681377284" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`8   Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
     </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-G3P600-and-G3P800.pdf?v=1677668629">View
            the report ></a>
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-wd-g3-n1cf-filter-replacement">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/waterdrop-cf-g3-icon1.png?v=1622532733"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N1CF
        </div>
        <div class="wd-compare-detail-item-text">
            CF-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/waterdrop-wd-g3-n3cb-filter-replacement">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/waterdrop-cb-g3-icon1.png?v=1622531945"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-G3-N3CB
        </div>
        <div class="wd-compare-detail-item-text">
            CB-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/g3p600-ro-system-replacement-filters">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/600.png?v=1699845933"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G3P600-N2RO
        </div>
        <div class="wd-compare-detail-item-text">
            RO-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(148))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'K6') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-K6-_-___1.png?v=1779162262')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr('src', 'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-K6-_-___1.png?v=1779162262')
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr(
          'href',
          'https://www.waterdropfilter.co.uk/products/reverse-osmosis-instant-hot-water-dispenser-system-wd-k6-w'
        )
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('600 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.42 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 240ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
  
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`45.7 × 43.2 × 43.2 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`14.5 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`5 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
        <a
            href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/Specification_Sheet_for_Reducing_Harmful_Substances-WD-K6.pdf?v=1677668629">View
            the report ></a>
    </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/kjf-filter-for-waterdrop-k6-instant-hot-ro-system-wd-kjf">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/KJF.png?v=1683790804"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-KJF
        </div>
        <div class="wd-compare-detail-item-text">
        KJF-12 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(130))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-temperature-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'G2P600') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G2P600_d17e3e16-aef0-46dc-b616-7361db2d03cd.png?v=1744008074'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/WD-G2P600_d17e3e16-aef0-46dc-b616-7361db2d03cd.png?v=1744008074'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr(
          'href',
          'https://www.waterdropfilter.co.uk/products/reverse-osmosis-water-filtration-system-for-home-wd-g2600-w'
        )
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('600 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.42 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 240ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`43.9 × 15.0 × 35.3 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`9.5 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`7 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/wd-g2cf-filter-for-wd-g2-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/WD-G2SeriesReverseOsmosisSystem_2_9cfa9f9a-25fb-44a2-8986-983a298fca1b.png?v=1626945096"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2CF
        </div>
        <div class="wd-compare-detail-item-text">
        CF-12 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/wd-g2p6mro-filter-for-wd-g2p600-w-reverse-osmosis-system">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/products/WD-G2P600-WReverseOsmosisSystem_1.png?v=1618820094"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-G2P6MRO  
        </div>
        <div class="wd-compare-detail-item-text">
        RO-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(81))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'X16') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x16-new-vis-main.png?v=1778148595'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x16-new-vis-main.png?v=1778148595'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/x16-undersink-reverse-osmosis-system')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('1600 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('1.11 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  2s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`46.2 × 15.9 × 42.5 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`16.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`2 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 42, 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-ro-contrast-2024-5-8-icon.png?v=1715131458"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`11 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
    <a
        href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WC-13976_58_20230318.pdf?v=1711002285">View
        the report ></a>
</div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-system-replacement-filter-f1a">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-f1a_ff4a7604-1e26-482f-b8b3-2d2a3170afb5.png?v=1741595270"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1A
        </div>
        <div class="wd-compare-detail-item-text">
            F1A-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-filter-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-f2_b7b76dc9-cdfc-41bb-b6f0-f0a2a3b96026.png?v=1727173014"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-undersink-ro-filter-replacement-filter-x16-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x16-f3_85fa03cc-a88a-4174-8b44-85b4f94b7f35.png?v=1745219254"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X16-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(183.98))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon3.png?v=1715067027" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'X12') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x12-new-vis-main.png?v=1778666561'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x12-new-vis-main.png?v=1778666561'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/reverse-osmosis-system-x12')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-3_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('1200 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.83 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  3s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`46.2 × 15.9 × 42.5 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`16.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`2 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 42, 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-ro-contrast-2024-5-8-icon.png?v=1715131458"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`11 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce-svg.svg?v=1682313834" alt="">
    </div>
    <div class="wd-compare-detail-item-text">
        99.9% UV Sterilization Rate
    </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and
        chloride, viruses, bacteria, and other harmful substances<br><br>
        Heavy metals: chromium, lead, arsenic, iron, radium, and calcium<br><br>
        Dirt, dust, sand, chlorine, taste and odor, colloid, residual large particles, suspended
        solids, rust, sediment, large particles,
        scale
    </div>
    <div class="wd-compare-detail-item-a">
                            <a
                                href="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/WC-13976_58_20230318.pdf?v=1711002285">View
                                the report ></a>
                        </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-system-replacement-filter-f1a">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.com/cdn/shop/files/ui-wd-f1a-product.png?v=1762270049"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1A
        </div>
        <div class="wd-compare-detail-item-text">
            F1A-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-filter-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.com/cdn/shop/files/ui-wd-f2_FILTER.png?v=1776071155"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-undersink-ro-filter-replacement-filter-x16-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.com/cdn/shop/files/ui-wd-x12-f3-fIlter.png?v=1774516677"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X12-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(173.97))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-uv-svg.svg?v=1682313835" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon3.png?v=1715067027" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-contrast-ro-product-icon4.png?v=1715067027" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'X8') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/X8_e59ae616-924b-490e-a488-5e4aba06cc79.png?v=1765855313'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/X8_e59ae616-924b-490e-a488-5e4aba06cc79.png?v=1765855313'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/reverse-osmosis-system-x8')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-2_1-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('800 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.56 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  5s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`46.2 × 15.9 × 42.5 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`16.5 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 42, 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-2.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-3.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-4.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`9 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-reduce_none-svg.svg?v=1682313834" alt="" data-uw-rm-alt-original="" role="presentation" data-uw-rm-alt="SVG">
     </div>
    <div class="wd-compare-detail-item-longtext">
        TDS, PFAS, fluoride, chlorine, inorganic arsenic compounds, salts like nitrate and chloride, viruses, bacteria, and other harmful substances 
Heavy metals: chromium, lead, arsenic, iron, radium, and calcium
    </div>
    `)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-system-replacement-filter-f1a">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-f1a_ff4a7604-1e26-482f-b8b3-2d2a3170afb5.png?v=1741595270"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
            WD-F1G
        </div>
        <div class="wd-compare-detail-item-text">
            F1G-12 Mths 
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-reverse-osmosis-filter-replacement-filter-f2">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-f2_b7b76dc9-cdfc-41bb-b6f0-f0a2a3b96026.png?v=1727173014"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-F2
        </div>
        <div class="wd-compare-detail-item-text">
        F2-6 Mths
        </div>
    </a>
  </div>
  <div class="wd-compare-detail-item-a">
    <a href="https://www.waterdropfilter.co.uk/products/x-series-undersink-ro-filter-replacement-filter-x16-f3">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-x16-f3_85fa03cc-a88a-4174-8b44-85b4f94b7f35.png?v=1745219254"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        WD-X8-F3
        </div>
        <div class="wd-compare-detail-item-text">
        F3-24 Mths
        </div>
    </a>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(149.97))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'G5P500A') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-g5p500a-product_0790821d-f940-44cb-af65-55aacd58d631.png?v=1773042285'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-g5p500a-product_0790821d-f940-44cb-af65-55aacd58d631.png?v=1773042285'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/alkaline-ro-water-purifier-g5p500a')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-des-pure-img-2-1.png?v=1631002289" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('500 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.35 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  8s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`42.4 × 14.5 × 35.3 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`9.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`8 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        Reduces PFOA, PFOS, chlorine, lead, fluoride, heavy metals, TDS, sediment, Chromium-VI, microplastics, odor and more impurities.
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.com/cdn/shop/files/ui-wd-g5p500a-cf-product.png?v=1762271082"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        G5P500A-CF
        </div>
        <div class="wd-compare-detail-item-text">
        6 Mths
        </div>
  </div>
  <div class="wd-compare-detail-item-a">
        <div class="wd-compare-detail-item-img">
            <img src="https://www.waterdropfilter.com/cdn/shop/files/ui-wd-g5p500-ro-product.png?v=1762271082"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        G5P500-RO
        </div>
        <div class="wd-compare-detail-item-text">
        24 Mths
        </div>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(121.97))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    } else if (title == 'G5P700A') {
      $('.wd-compare-header .wd-compare-header-item')
        .eq(wd_compare_index)
        .find('.wd-compare-header-item-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-g5p700a-product.png?v=1765352596'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-img img')
        .attr(
          'src',
          'https://www.waterdropfilter.co.uk/cdn/shop/files/ui-wd-g5p700a-product.png?v=1765352596'
        )
      $('.wd-compare-product .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-product-shop a')
        .attr('href', 'https://www.waterdropfilter.co.uk/products/alkaline-ro-water-filter-for-tap-g5p700a')
      $('.wd-compare-detail-pure .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-des-pure-img-2-1.png?v=1631002289" alt="">`
        )
      $('.wd-compare-detail-flow_capacity .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('700 GPD')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html('0.49 GPM')
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg_text')
        .html(`<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-flow-svg.svg?v=1682313834" alt="">
  6s`)
      $('.wd-compare-detail-flow_rate .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-subtext-oz')
        .html(`*The capacity of the glass is 180ml`)
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(0)
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(1)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-dispensing_option .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .eq(2)
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-dispensing_none-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-installation .wd-compare-detail-item').eq(wd_compare_index).html(`
      <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-1-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Need Installation
  </div>
  <div class="wd-compare-detail-item-svg">
      <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-installation-2-svg.svg?v=1682313834" alt="">
  </div>
  <div class="wd-compare-detail-item-subtext">
      Drill a hole in the countertop
  </div>
    `)
      $('.wd-compare-detail-dimensions .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`42.4 × 14.5 × 35.3 cm`)
      $('.wd-compare-detail-item_weight .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`9.7 kg`)
      $('.wd-compare-detail-warranty .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`1 Year`)
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-usage_scenario-svg1.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-usage_scenario .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(`Undersink`)

      $('.wd-compare-detail-nsf .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-8.png?v=1685341817"
            alt="">
        <div class='wd-compare-detail-item-subtext wd-compare-detail-item-subtext-oz'>NSF/ANSI 58 & 372</div>
    </div>`)

      $('.wd-compare-detail-fcc .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-ce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-reddot_design .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835"
            alt="">
    </div>`)

      $('.wd-compare-detail-sgs .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-img">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-page-icon-5.png?v=1681377284"
            alt="">
    </div>`)

      $('.wd-compare-detail-tuv .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-ul .wd-compare-detail-item').eq(wd_compare_index)
        .html(` <div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>`)

      $('.wd-compare-detail-filtration .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-bigtext')
        .html(`8 Stages`)
      $('.wd-compare-detail-reduce .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-svg">
        <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-certification_test_svg.svg?v=1682313835" alt="">
    </div>
    <div class="wd-compare-detail-item-longtext">
        Reduces PFOA, PFOS, chlorine, lead, fluoride, heavy metals, TDS, sediment, Chromium-VI, microplastics, odor and more impurities.
    </div>`)

      $('.wd-compare-detail-filter_life_span .wd-compare-detail-item').eq(wd_compare_index)
        .html(`<div class="wd-compare-detail-item-a">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0563/3422/1485/files/ui-wd-g5p700a-cf-product_b42c9ab4-9bff-498e-b184-57a173db5e2a_800x800.png?v=1783410132"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        G5P700A-CF
        </div>
        <div class="wd-compare-detail-item-text">
        6 Mths
        </div>
  </div>
  <div class="wd-compare-detail-item-a">
        <div class="wd-compare-detail-item-img">
            <img src="https://cdn.shopify.com/s/files/1/0563/3422/1485/files/ui-wd-g5p700-ro-product_56ed2438-5cc9-43f4-8059-8b3ab7c7eb3a_800x800.png?v=1783410135"
                alt="">
        </div>
        <div class="wd-compare-detail-item-text">
        G5P700-RO
        </div>
        <div class="wd-compare-detail-item-text">
        24 Mths
        </div>
  </div>`)

      $('.wd-compare-detail-average .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-text')
        .html(formatGbp(110.97))

      $('.wd-compare-detail-filter_life .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-filter.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-tds .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-tds-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-temperature .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-uv .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-self .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-self-svg.svg?v=1682313834" alt="">`
        )

      $('.wd-compare-detail-smart .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart-svg.svg?v=1682313835" alt="">`
        )
      $('.wd-compare-detail-adjustable .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          ` <img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-smart_none-svg.svg?v=1682313834" alt="">`
        )
      $('.wd-compare-detail-sound .wd-compare-detail-item')
        .eq(wd_compare_index)
        .find('.wd-compare-detail-item-svg')
        .html(
          `<img src="https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-compare-sound-svg.svg?v=1682313834" alt="">`
        )
    }
  }
})
